/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { setActiveSectionId, setActiveSubSectionId, setSidebarOpen } from '../../../redux/slices/viewCourseSlice';
import { FaHandPointRight } from 'react-icons/fa';
import { PiSealBold, PiSealCheckBold } from 'react-icons/pi';
import { ACCOUNT_TYPE } from '../../../utils/constants';
import { BiEdit } from 'react-icons/bi';
import BgBlurModal from '../../common/BgBlurModal';
import { useForm } from 'react-hook-form';
import CreateSection from './instructorSpecific/CreateSection';
import ConfirmationModal from '../../common/ConfirmationModal';
import UpdateSection from './instructorSpecific/UpdateSection';
import UpdateSubSection from './instructorSpecific/UpdateSubSection';
import Hamburger from 'hamburger-react';

const SideBarOfViewCourse = () => {
    const navigate = useNavigate();
    const { sectionId } = useParams();
    const dispatch = useDispatch();
    const [sectionID, setSectionID] = useState(sectionId);
    let sectionRefs = useRef({});
    const ref = useRef();
    const { user } = useSelector(state => state.profile);
    const [bgBlurModal, setBgBlurModal] = useState(null);
    const [confirmationModal, setConfirmationModal] = useState(null);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    window.addEventListener('resize', () => {
        setScreenWidth(window.innerWidth);
    })
    const {
        courseSectionData,
        courseEntireData,
        completedLectures,
        totalNoOfLectures,
        activeSectionId,
        activeSubSectionId,
        isSidebarOpen,
    } = useSelector(state => state.viewCourse);

    const {
        register,
        setValue,
        getValues,
        formState: { errors }
    } = useForm();

    const editCourseInformationHandler = () => {
        // TODO: Implement the logic for editing course information
    }

    useEffect(() => {
        for (const sectionRef in sectionRefs?.current) {
            if (sectionRefs.current[sectionRef]) {
                const sectionHeight =
                    sectionRef === activeSectionId ?
                        sectionRefs.current[sectionRef].scrollHeight + 'px' : '0px'

                sectionRefs.current[sectionRef].style.height = sectionHeight;
            }
        }
    }, [activeSectionId, sectionID, courseSectionData])

    return (
        <div className={`${screenWidth < 1024 ? 'absolute top-0 left-0 w-[18rem]' : 'w-[25rem]'} ${isSidebarOpen ? 'h-full z-50' : screenWidth < 1024 && 'h-[0vh] opacity-0'} text-richblack-5 bg-richblack-800 border-r pt-3 pb-5 transition-all duration-200 border-r-richblack-700`}>
            {screenWidth < 1024 &&
                <div ref={ref} onClick={() => isSidebarOpen ? dispatch(setSidebarOpen(false)) : dispatch(setSidebarOpen(true))} className='text-white md:scale-y-[0.85] scale-[0.75] flex w-fit relative left-[15rem] justify-end'>
                    <Hamburger toggled={isSidebarOpen} className='focus:bg-none z-50' />
                </div>
            }
            <div className='mx-5 flex flex-col items-start justify-between gap-2 gap-y-4 border-b border-richblack-600 py-3 text-lg font-bold text-richblack-25'>
                <div className='flex flex-col w-full'>
                    <div className='flex items-center justify-between'>
                        <p>{courseEntireData?.courseName}</p>
                        {user.accountType === ACCOUNT_TYPE.INSTRUCTOR &&
                            <button
                                type='button'
                                onClick={editCourseInformationHandler}
                            >
                                <BiEdit />
                            </button>
                        }
                    </div>
                    <p className='text-sm font-semibold mt-1 text-richblack-500'>
                        {user.accountType === ACCOUNT_TYPE.INSTRUCTOR ? <span>Total Lectures {totalNoOfLectures}</span> : <span>{completedLectures?.length} / {totalNoOfLectures}</span>}
                    </p>
                </div>
            </div>
            <div className='mt-5'>
                {user.accountType === ACCOUNT_TYPE.INSTRUCTOR &&
                    <CreateSection
                        moduleType='create'
                        register={register}
                        getValues={getValues}
                        setValue={setValue}
                        setBgBlurModal={setBgBlurModal}
                        courseId={courseEntireData?._id}
                    />
                }
                <div className='w-full bg-richblack-700 text-richblack-5 flex flex-col'>
                    {courseSectionData.map((section, index) => (
                        <div key={index}>
                            <div
                                className='flex cursor-pointer justify-between items-center text-[16px] py-3 px-3 my-1'
                                onClick={() => {
                                    dispatch(setActiveSectionId(section?._id))
                                    setSectionID(section?._id)
                                }}>
                                <div>
                                    <button type='button'
                                    >
                                        {activeSectionId !== section?._id ? (
                                            <FaHandPointRight
                                                className='transition-all duration-200'
                                            />
                                        ) : (
                                            <FaHandPointRight
                                                className='rotate-90 transition-all duration-200'
                                            />
                                        )}
                                    </button>
                                </div>
                                <div
                                    className='w-full overflow-hidden pl-5 bg-richblack-700 text-richblack-5'
                                >
                                    {section?.sectionName}
                                </div>
                                {user.accountType === ACCOUNT_TYPE.INSTRUCTOR &&
                                    <UpdateSection
                                        moduleType='update'
                                        register={register}
                                        errors={errors}
                                        getValues={getValues}
                                        setValue={setValue}
                                        setBgBlurModal={setBgBlurModal}
                                        setConfirmationModal={setConfirmationModal}
                                        section={section}
                                    />
                                }
                            </div>
                            <div
                                className={`transition-all overflow-hidden duration-300 bg-richblack-800`}
                                ref={(ref) => (sectionRefs.current[section?._id] = ref)}
                            >
                                {
                                    section.subSection.map((subSection, index) => (
                                        <div key={index}>
                                            <div className={`flex justify-between text-[15px] py-2 font-medium ${activeSubSectionId === subSection?._id ? 'bg-yellow-100 text-richblack-900' : 'bg-richblack-800 text-richblack-5'} items-center pl-7 pr-2 border-b border-richblack-700`}>
                                                <div className='flex items-center gap-x-3 py-1 w-full cursor-pointer'
                                                    onClick={() => {
                                                        dispatch(setActiveSubSectionId(subSection?._id));
                                                        navigate(`/course/${courseEntireData?.courseName.toLowerCase()}/${courseEntireData?._id}/${section?._id}/${subSection?._id}`)
                                                    }}>
                                                    {user.accountType === ACCOUNT_TYPE.STUDENT &&
                                                        <div className='text-[16px]'>
                                                            {completedLectures.includes(subSection?._id) ?
                                                                <PiSealCheckBold className='text-lg' /> :
                                                                <PiSealBold className='text-lg' />
                                                            }
                                                        </div>
                                                    }
                                                    <div
                                                        className='w-[15rem] overflow-x-hidden sub-section-text whitespace-nowrap hover:overflow-x-auto focus:overflow-x-auto'
                                                    >
                                                        {subSection.title}
                                                    </div>
                                                    {user.accountType === ACCOUNT_TYPE.INSTRUCTOR &&
                                                        <UpdateSubSection
                                                            subSection={subSection}
                                                            sectionId={section._id}
                                                            setConfirmationModal={setConfirmationModal}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            {bgBlurModal &&
                <BgBlurModal setBgBlurModal={setBgBlurModal}>
                    {bgBlurModal}
                </BgBlurModal>
            }
            {confirmationModal &&
                <ConfirmationModal modalData={confirmationModal} />
            }
        </div>
    );
};

export default SideBarOfViewCourse;